export enum SeasonEnum {
  summer = 0,
  winter = 1,
  allSeason = 2,
}

export const SeasonList = [
  {
    season: SeasonEnum.summer,
    title: 'Лето',
    className: 'seasonFilterBtn_summer',
  },
  {
    season: SeasonEnum.winter,
    title: 'Зима',
    className: 'seasonFilterBtn_winter',
  },
  {
    season: null,
    title: 'Все',
    className: 'seasonFilterBtn_all',
  },
];

export const stringToSeason = (season: string) => {
  if (season === 'leto') {
    return SeasonEnum.summer;
  } else if (season === 'zima') {
    return SeasonEnum.winter;
  } else if (season === 'all') {
    return SeasonEnum.allSeason;
  }

  return null;
};

export const seasonTitle = (season: SeasonEnum) => {
  return SeasonList.find(s => s.season === season)?.title;
};

export const seasonToString = (season: SeasonEnum) => {
  if (season === SeasonEnum.summer) {
    return 'leto';
  } else if (season === SeasonEnum.winter) {
    return 'zima';
  } else if (season === SeasonEnum.allSeason) {
    return 'all';
  }

  return null;
};

export const findSeasonIdx = (s: string[]) => {
  return s && s.find(x => x === 'leto' || x === 'zima' || x === 'all');
};

export const isSeason = (s: string) => {
  return s === 'leto' || s === 'zima' || s === 'all';
};
